import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { errorStatus, extractApiErrorMessage, isClientError, isRetriableError } from './errors';
import { notifyError } from './toastBridge';

const SILENT_STATUSES = new Set([304, 401, 403, 404]);

function shouldToast(error: unknown): boolean {
  const status = errorStatus(error);
  if (status != null && SILENT_STATUSES.has(status)) return false;
  return true;
}

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      if (shouldToast(error)) {
        notifyError(extractApiErrorMessage(error));
      }
    },
  }),
  mutationCache: new MutationCache({
    onError: (error) => {
      if (shouldToast(error)) {
        notifyError(extractApiErrorMessage(error));
      }
    },
  }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (isClientError(error)) return false;
        return isRetriableError(error) && failureCount < 2;
      },
      retryDelay: (attempt) => Math.min(1000 * 2 ** attempt, 15_000),
    },
    mutations: {
      retry: 0,
    },
  },
});
